import TableReportHelper from "report/helper";
import DCorIndicadorReportSummary from "./DCorIndicadorReportSummary";

export default async function dcorReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    // const chartSegments = [0, 76, parseInt(params.meta), 100];

    const statusColors = (status) => {
        switch (status) {
            case "Ótimo":
                return "#6bd72d"
            case "Bom":
                return "#6bd72d"
            case "Regular":
                return "#ecdb23"
            case "Ruim":
                return "#fe4719"
            default:
                return "#fe4719"
        }
    }

    async function getChart(conformidade, status) {
        let barColor = statusColors(status)
        return h.barChart(
            {
                columns: ["Esquerda", "Centro", "Direita"],
                domain: [0, 100],
                width: 500,
                height: 130,
                series: [
                    { name: "Esquerda", values: [conformidade], props: { type: "monotone", fill: barColor } },
                    { name: "Centro", values: [conformidade], props: { type: "monotone", fill: barColor } },
                    { name: "Direita", values: [conformidade], props: { type: "monotone", fill: barColor } },
                ],
            },
            { alignment: "center", colSpan: 3 }
        );
    }

    return DCorIndicadorReportSummary(indicador, visita, tipoName, params, getChart);
}

